const Resume = () =>
  import(/* webpackChunkName: "resume" */ "@/app/admin/resume/resume");
const ResumeDetail = () =>
  import(/* webpackChunkName: "resume" */ "@/app/admin/resume/resume-detail");

export default [
  {
    path: "resume",
    name: "resume",
    component: Resume,
    meta: { title: "简历管理", key: "resume", permission: "resume_manager" }
  },
  {
    path: "resume/detail/:id",
    name: "resume-detail",
    component: ResumeDetail,
    meta: { title: "简历详情", key: "resume" }
  }
];
